import {
  Archive,
  EditPencil,
  LogOut,
  ShieldCheck,
  Trash,
  UserPlus,
  UTurnArrowRight,
} from 'iconoir-react';
import type { ComponentType, SVGProps } from 'react';

import { ProjectFolderIcon } from './project-folder-icon';

const conversationMenuIcons: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  rename: EditPencil,
  'start-group-chat': UserPlus,
  archive: Archive,
  delete: Trash,
  leave: LogOut,
  remove: UTurnArrowRight,
  'chat-permissions': ShieldCheck,
};

const projectFolderOptionIds = new Set(['add-to-project', 'folder', 'new-project']);

function usesProjectFolderIcon(optionId: string): boolean {
  if (projectFolderOptionIds.has(optionId)) return true;
  return !(optionId in conversationMenuIcons);
}

interface ConversationMenuIconProps {
  optionId: string;
}

export function ConversationMenuIcon({ optionId }: ConversationMenuIconProps) {
  if (usesProjectFolderIcon(optionId)) {
    return <ProjectFolderIcon />;
  }

  const Icon = conversationMenuIcons[optionId];

  return <Icon width={20} height={20} strokeWidth={1.5} className="shrink-0" />;
}
